import "./index.scss";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Responsive } from "./responsive";
import { Provider } from "react-redux";
import { store } from "@/src/store";
import PushNotificationsProvider from "@/src/components/CustomUtils/PushNotifications/PushNotificationsProvider";

window.addEventListener("resize", Responsive);
Responsive();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <PushNotificationsProvider>
      <App />
    </PushNotificationsProvider>
  </Provider>
);
